import { WixPatternsEssentials } from '@wix/bex-core';

export type WixPatternsMinimalEssentials = Omit<
  WixPatternsEssentials,
  'useExperiments' | 'experiments' | 'Trans' | 'user'
> & {
  useExperiments?: WixPatternsEssentials['useExperiments'];
  experiments?: WixPatternsEssentials['experiments'];
  Trans?: WixPatternsEssentials['Trans'];
  user?: WixPatternsEssentials['user'];
};
